import React from 'react';
import { Translate } from 'react-localize-redux';
import AvatarIcon from '../../components/atoms/AvatarIcon';
import Button from '../../components/atoms/Button';
import { IconSizes, IconVariants } from '../../components/foundations/Icon';
import { TRANSLATION_KEY } from '../constants';
import { connectionItemShape } from '../propShapes';
import css from './ConnectionRow.css';

const ConnectionRow = ({ item }) => {
    const { name, description, statusText, Logo, connected, busy, onConnect, onDisconnect } = item;

    return (
        <div className={css.row}>
            <div className={css.logoWrapper}>
                <AvatarIcon className={css.logoTile}>
                    <Logo className={css.logo} />
                </AvatarIcon>
                {connected && <span className={css.connectedDot} />}
            </div>
            <div className={css.text}>
                <span className={css.name}>{name}</span>
                <span className={css.subtitle}>{statusText ?? description}</span>
            </div>
            {connected ? (
                <Button type="flat" className={css.disconnect} showSpinner={busy} onClick={onDisconnect}>
                    <Translate id={`${TRANSLATION_KEY}.DISCONNECT`} />
                </Button>
            ) : (
                <Button
                    type="link"
                    className={css.connect}
                    Icon="plus"
                    iconSize={IconSizes.X_SMALL}
                    iconVariant={IconVariants.ACTIVE}
                    iconClass={css.connectIcon}
                    showSpinner={busy}
                    onClick={onConnect}
                >
                    <Translate id={`${TRANSLATION_KEY}.CONNECT`} />
                </Button>
            )}
        </div>
    );
};

ConnectionRow.propTypes = {
    item: connectionItemShape.isRequired,
};

export default ConnectionRow;
